import { siteInfo } from '@/mocks/homeData';

export default function HeroSection() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-16 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 max-w-6xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
              <span>今日吃瓜 · 全网首发</span>
            </div>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-3">
              51吃瓜网今日吃瓜资源
              <br />
              <span className="text-primary-500">网红动态聚合平台</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-body mb-2">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              {siteInfo.stats.map((stat, i) => (
                <div key={i} className="flex items-center gap-2 text-sm text-foreground-600">
                  <div className="w-2 h-2 rounded-full bg-accent-500"></div>
                  <span className="font-medium">{stat}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => handleScrollTo(e, '#cards')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 dark:text-foreground-950 font-medium rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-rocket-line w-4 h-4 flex items-center justify-center"></i>
                {siteInfo.cta_primary}
              </a>
              <a
                href="#index"
                onClick={(e) => handleScrollTo(e, '#index')}
                className="inline-flex items-center gap-2 px-6 py-3 border-2 border-primary-300 text-primary-700 font-medium rounded-full hover:bg-primary-50 transition-all whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-user-star-line w-4 h-4 flex items-center justify-center"></i>
                {siteInfo.cta_secondary}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-primary-200/40 via-accent-200/30 to-secondary-200/40 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=A%20vibrant%20editorial%20collage%20of%20entertainment%20and%20social%20media%20culture%2C%20warm%20pink%20and%20orange%20lighting%2C%20modern%20trendy%20aesthetic%2C%20dynamic%20composition%20with%20pop%20culture%20elements%2C%20high%20quality%20commercial%20photography%2C%20clean%20minimal%20background&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                alt="51吃瓜网网红动态聚合平台主视觉"
                className="relative w-full h-auto rounded-2xl object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}